import { render } from "./studentStudyRecord.vue?vue&type=template&id=1753d254&scoped=true"
import script from "./studentStudyRecord.vue?vue&type=script&lang=js"
export * from "./studentStudyRecord.vue?vue&type=script&lang=js"

import "./studentStudyRecord.vue?vue&type=style&index=0&id=1753d254&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1753d254"]])

export default __exports__